import React from 'react'
import ProcessBar from '../../../components/global/charts/ProcessBar';
import { useNavigate } from 'react-router-dom';

const TransactionCard = ({ title, data }) => {
    const navigate = useNavigate();
    return (
        <>
            <div>
                {title && <p className='font-medium text-lg mb-4'>{title}</p>}
                <div>
                    <div className='grid grid-cols-2 divide-x-2'>
                        <div className='flex flex-col items-start gap-2 '>
                            <div className='flex items-center gap-3 cursor-pointer' onClick={() => navigate(data[0]?.navigate)}>
                                <div className={`${data[0]?.bgColor} p-1 w-8 h-8 rounded-lg flex items-center justify-center`}>{data[0]?.icon}</div>
                                <p className='text-xl'>{data[0]?.count || 0}</p>
                            </div>
                            <p className='text-gray-500 cursor-pointer' onClick={() => navigate(data[0]?.navigate)}>{data[0]?.name || ''}</p>
                        </div>

                        <div className='flex flex-col items-end gap-2'>
                            <div className='flex items-center gap-3 cursor-pointer' onClick={() => navigate(data[1]?.navigate)}>
                                <p className='text-xl'>{data[1]?.count || 0}</p>
                                <div className={`${data[1]?.bgColor} p-1 w-8 h-8 rounded-lg flex items-center justify-center`}>{data[1]?.icon}</div>
                            </div>
                            <p className='text-gray-500 cursor-pointer' onClick={() => navigate(data[1]?.navigate)}>{data[1]?.name || ''}</p>
                        </div>
                    </div>

                    <div className='mt-5'>
                        <ProcessBar data={data} />
                    </div>
                </div>
            </div>
        </>
    )
}

export default TransactionCard;
